import { MutationTree } from 'vuex';
import { EDocumentsMutation } from './documents.constants';
import { IDocumentsState } from './documents.types';
import { IDocument } from '@lib-shared/types/Document';

export const mutations: MutationTree<IDocumentsState> = {
  [EDocumentsMutation.SetIsLoadingDocuments](state, payload: boolean) {
    state.isLoadingDocuments = payload;
  },
  [EDocumentsMutation.SetDocuments](state, documents: IDocument[]) {
    state.documents = documents;
  },
  [EDocumentsMutation.SetError](state, error: boolean) {
    state.error = error;
  },
};
